import { jwtDecode } from 'jwt-decode';
import React, { useEffect, useState } from 'react';

function Card() {
    const baseUrl =
        process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_BASE_URL_DEV
            : process.env.REACT_APP_BASE_URL_PROD;

    const [data, setData] = useState([]);
    const [summary, setSummary] = useState({
        pending: 0,
        completed: 0,
        totalRevenue: 0
    });

    useEffect(() => {
        const token = localStorage.getItem("tokenfirst");
        if (!token) {
            console.error("No token found.");
            return;
        }

        const decodedToken = jwtDecode(token);
        const vendorId = decodedToken.email;

        if (!vendorId) {
            console.error("Invalid token: vendorId is missing.");
            return;
        }

        fetch(`${baseUrl}/bookingvendor/bookingbyId/${vendorId}`, {
            method: "GET",
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {
                if (data && data.bookingsData) {
                    const allBookings = data.bookingsData;
                    setData(allBookings);
                    calculateSummary(allBookings);
                } else {
                    console.error(data.message);
                }
            })
            .catch((error) => {
                console.error("There was a problem with the fetch operation:", error);
            });
    }, []);

   const calculateSummary = (bookings) => {
    let pending = 0;
    let completed = 0;
    let totalRevenue = 0;

    bookings.forEach(item => {
        if (item.bookingstatus === "Pending") pending++;
        if (item.bookingstatus === "Completed") {
            completed++;
            if (item.totals?.overallTotal) {
                totalRevenue += item.totals.overallTotal;
            }
        }
    });

    setSummary({ pending, completed, totalRevenue });
};


    const dataCard = [
        {
            title: 'PENDING ORDERS',
            value: summary.pending,
            svg: (
                <svg width="24" height="14" viewBox="0 0 24 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13.8838 0.602524L23.108 5.66265C23.3212 5.77951 23.4984 5.94966 23.6218 6.15551C23.7453 6.36143 23.8103 6.59563 23.8103 6.83418C23.8103 7.07273 23.7453 7.30692 23.6218 7.51286C23.4984 7.71871 23.3212 7.88885 23.108 8.00571L13.8839 13.0661C13.2951 13.389 12.6313 13.5587 11.956 13.5587C11.2806 13.5587 10.6168 13.389 10.0281 13.0661L0.803867 8.00571C0.590835 7.88885 0.413484 7.71871 0.290055 7.51286C0.166628 7.30692 0.101562 7.07273 0.101562 6.83418C0.101562 6.59563 0.166628 6.36143 0.290055 6.15551C0.413484 5.94966 0.590835 5.77951 0.803867 5.66265L10.0281 0.602524C10.6168 0.279576 11.2806 0.109985 11.956 0.109985C12.6313 0.109985 13.2951 0.279576 13.8838 0.602524Z" fill="#2A668D" />
                </svg>
            )
        },
        {
            title: 'COMPLETED ORDERS',
            value: summary.completed,
            svg: (
                <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clipPath="url(#clip0)">
                        <path d="M18.5781 0.602524L27.799 5.66265C28.0121 5.77951 28.1892 5.94966 28.3126 6.15551C28.436 6.36143 28.501 6.59563 28.501 6.83418C28.501 7.07273 28.436 7.30692 28.3126 7.51286C28.1892 7.71871 28.0121 7.88885 27.799 8.00571L18.5782 13.0661C17.9896 13.389 17.326 13.5587 16.651 13.5587C15.9758 13.5587 15.3122 13.389 14.7238 13.0661L5.50284 8.00571C5.28989 7.88885 5.1126 7.71871 4.98921 7.51286C4.86583 7.30692 4.80078 7.07273 4.80078 6.83418C4.80078 6.59563 4.86583 6.36143 4.98921 6.15551C5.1126 5.94966 5.28989 5.77951 5.50284 5.66265L14.7238 0.602524C15.3122 0.279576 15.9758 0.109985 16.651 0.109985C17.326 0.109985 17.9896 0.279576 18.5781 0.602524Z" fill="#2A668D" />
                        <path opacity="0.7" d="M18.5277 5.35303L31.7334 12.5999C31.9464 12.7168 32.1237 12.887 32.2471 13.0928C32.3705 13.2987 32.4355 13.5329 32.4355 13.7715C32.4355 14.0101 32.3705 14.2442 32.2471 14.4502C32.1237 14.6561 31.9464 14.8261 31.7334 14.9431L18.5277 22.1899C17.9392 22.5127 17.2756 22.6825 16.6006 22.6825C15.9255 22.6825 15.2619 22.5127 14.6735 22.1899L1.46768 14.9431C1.25472 14.8261 1.07743 14.6561 0.954049 14.4502C0.830664 14.2442 0.765625 14.0101 0.765625 13.7715C0.765625 13.5329 0.830664 13.2987 0.954049 13.0928C1.07743 12.887 1.25472 12.7168 1.46768 12.5999L14.6735 5.35303C15.2619 5.03016 15.9255 4.86057 16.6006 4.86057C17.2756 4.86057 17.9392 5.03016 18.5277 5.35303Z" fill="#2A668D" />
                    </g>
                </svg>
            )
        },
        {
            title: 'TOTAL REVENUE',
            value: `${summary.totalRevenue} INR`,
            svg: (
                <svg width="44" height="34" viewBox="0 0 44 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clipPath="url(#clip1)">
                        <path d="M23.1011 0.602463L32.3231 5.66259C32.5362 5.77945 32.7134 5.9496 32.8368 6.15545C32.9602 6.36137 33.0253 6.59557 33.0253 6.83412C33.0253 7.07267 32.9602 7.30686 32.8368 7.5128C32.7134 7.71865 32.5362 7.88878 32.3231 8.00565L23.1012 13.066C22.5126 13.389 21.8489 13.5587 21.1738 13.5587C20.4986 13.5587 19.8349 13.389 19.2464 13.066L10.0244 8.00565C9.81143 7.88878 9.63412 7.71865 9.51072 7.5128C9.38732 7.30686 9.32227 7.07267 9.32227 6.83412C9.32227 6.59557 9.38732 6.36137 9.51072 6.15545C9.63412 5.9496 9.81143 5.77945 10.0244 5.66259L19.2464 0.602463C19.8349 0.279515 20.4986 0.109924 21.1738 0.109924C21.8489 0.109924 22.5126 0.279515 23.1011 0.602463Z" fill="#2A668D" />
                        <path opacity="0.7" d="M23.0512 5.35297L36.2585 12.5998C36.4714 12.7167 36.6488 12.8869 36.7722 13.0927C36.8956 13.2987 36.9606 13.5329 36.9606 13.7714C36.9606 14.0099 36.8956 14.2442 36.7722 14.4501C36.6488 14.656 36.4714 14.8261 36.2585 14.943L23.0512 22.1898C22.4626 22.5127 21.799 22.6824 21.1238 22.6824C20.4487 22.6824 19.785 22.5127 19.1965 22.1898L5.98924 14.943C5.77626 14.8261 5.59895 14.656 5.47555 14.4501C5.35215 14.2442 5.28711 14.0099 5.28711 13.7714C5.28711 13.5329 5.35215 13.2987 5.47555 13.0927C5.59895 12.8869 5.77626 12.7167 5.98924 12.5998L19.1965 5.35297C19.785 5.0301 20.4487 4.8605 21.1238 4.8605C21.799 4.8605 22.4626 5.0301 23.0512 5.35297Z" fill="#2A668D" />
                    </g>
                </svg>
            )
        },
    ];

    return (
        <div className="flex space-x-6">
            {dataCard.map((item, index) => (
                <div
                    key={index}
                    className="w-[350px] h-[180px] bg-white rounded-lg shadow border flex flex-col justify-center items-start pl-4 space-y-3"
                >
                    <div className='mb-8'>{item.svg}</div>
                    <div className="text-2xl font-semibold">{item.value}</div>
                    <div className="text-sm text-gray-500">{item.title}</div>
                </div>
            ))}
        </div>
    );
}

export default Card;
